import React from "react";
import Navbar from "../../../Navbar/Navbar";
import { ProductConsumer } from "../../../Context/AddProWakel";
import swal from "sweetalert";
import errorAduio from "./../../../img/error.mp4";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Instance from "../../../util/Instance";

class AllMarket extends React.Component {
    constructor() {
        super();
        this.state = {
            savekrdn: false,
            newpage: true
        };
    }

    onSaveChange = (IT_name, IT_table, callback, e) => {
        if (!window.navigator.onLine) {
            swal({
                title: "ببورە",
                text: "هێڵی ئنتەرنێتەکەت کێشەی هەیە",
                icon: "error"
            });
        } else if (IT_table.length == 0) {
            const sawtError = new Audio(errorAduio);
            sawtError.play().catch(() => { });
            swal({
                title: "ببورە",
                text: "هەڵە هەیە لە خانەکان",
                icon: "error"
            });
        } else if (!IT_name) {
            const sawtError = new Audio(errorAduio);
            sawtError.play().catch(() => { });
            swal({
                title: "ببورە",
                text: "هەڵە هەیە لە خانەکان",
                icon: "error"
            });
        } else {
            callback(e);
            this.setState({
                savekrdn: true,
                newpage: false
            });
            localStorage.removeItem("item");
        }
    };

    onNewPage = () => {
        this.setState({
            savekrdn: false
        });
    };

    render() {
        return (
            <>
                <Navbar />
                <ProductConsumer>
                    {(value) => {
                        console.log("🔍 Checking IT_OnDanaChange in context:", typeof value.IT_OnDanaChange);
                        console.log("🔍 IT_isEdited:", value.IT_isEdited);
                        console.log("🔍 IT_dana:", value.IT_dana);
                        
                        const {
                            AddProChange,
                            IT_name,
                            IT_phone,
                            IT_code,
                            IT_no_invoice,
                            IT_get_Invoice,
                            IT_OnChangeSwitch,
                            IT_joripara,
                            IT_Note,
                            IT_itemName,
                            IT_searchItemName,
                            IT_setItemEmpty,
                            IT_disabled,
                            IT_table,
                            IT_deleteItem,
                            IT_openEditModel,
                            IT_total,
                            IT_discount,
                            IT_paied,
                            IT_save,
                            IT_saved,
                            IT_createNewPage,
                            IT_disCount,
                            IT_countChange,
                            IT_remain,
                            IT_invoiceId,
                            IT_openInvoice,
                            IT_updateInvoice,
                            IT_isOpen,
                            getPrint,
                            IT_open,
                            dinartodolar,
                            dolartodinar,
                            L_user,
                            IT_isEdited,
                            IT_dana,
                            IT_ItemData,
                            IT_updateItemInTable,
                            IT_closeModel,
                            IT_onKeyUP,
                            IT_karton,
                            IT_darzan,
                            IT_OnDanaChange,
                            IT_OnDarzanChange,
                            IT_OnKartonChange,
                            IT_OnNrxChange,
                            IT_nrx,
                            IT_items,
                            IT_saveDetail,
                            IT_froshtn,
                            IT_prevPage,
                            IT_totalPages,
                            DecimalNumber,
                            IT_pageminsone,
                            IT_pageplusone,
                            IT_dp,
                            IT_rasidKarton,
                            IT_price,
                            IT_Karton_price,
                            IT_saleDolar,
                            IT_nrxeFroshtnDolar2,
                            IT_saleDinar,
                            IT_nrxeFroshtnDenar2,
                            IT_saleOfLessHalfCarton,
                            IT_saleOfLessTenDarzan,
                            IT_singleSale,
                            IT_productNumber,
                            IT_qazanj,
                            IT_metr,
                            IT_remembi,
                            IT_editProfit,
                            IT_OnMetrChange,
                            IT_OnRememberChange,
                        } = value;

                        return (
                            <div style={{ marginTop: "3.5em" }}>
                                {/* Header Section */}
                                <form>
                                    <div className="row align-items-end text-warning font-weight-bold py-2 px-2" style={{ backgroundColor: "#2C3539" }}>
                                        {/* جۆری پارە */}
                                        <div className="col-2 text-right">
                                            <div className="form-group mb-0">
                                                <label className="mb-1" style={{ fontSize: "12px" }}>:جۆری پارە</label>
                                                <select
                                                    className={`form-control text-right font-weight-bold ${IT_joripara === "دۆلار" ? "bg-success text-white" :
                                                        IT_joripara === "دینار" ? "bg-danger text-white" : ""
                                                        }`}
                                                    onChange={IT_OnChangeSwitch}
                                                    name="IT_joripara"
                                                    value={IT_joripara || ""}
                                                    disabled={IT_disabled}
                                                >
                                                    <option className="ml5">جۆری پارە</option>
                                                    <option>دۆلار</option>
                                                    <option>دینار</option>
                                                </select>
                                            </div>
                                        </div>
                                        {/* قازانج */}
                                        <div className="col-1 text-center">
                                            <div className="form-group mb-0">
                                                <div
                                                    className={`form-control text-center font-weight-bold ${Number(IT_qazanj) >= 0 ? "bg-success text-white" : "bg-danger text-white"}`}
                                                    style={{ fontSize: "14px", padding: "6px 4px" }}
                                                >
                                                    $ {Number(IT_qazanj).toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                        {/* تەلەفۆن */}
                                        <div className="col-2 text-right">
                                            <div className="form-group mb-0">
                                                <label className="mb-1" style={{ fontSize: "12px" }}>:تەلەفۆن</label>
                                                <input
                                                    type="text"
                                                    value={IT_phone}
                                                    disabled={IT_disabled}
                                                    name="IT_phone"
                                                    onChange={AddProChange}
                                                    className="form-control text-right font-weight-bold"
                                                />
                                            </div>
                                        </div>
                                        {/* بەڕێز */}
                                        <div className="col-2 text-right">
                                            <div className="form-group mb-0">
                                                <label className="mb-1" style={{ fontSize: "12px" }}>:بەڕێز</label>
                                                <input
                                                    type="text"
                                                    value={IT_name}
                                                    name="IT_name"
                                                    disabled={IT_disabled}
                                                    onChange={AddProChange}
                                                    className="form-control text-right font-weight-bold"
                                                />
                                            </div>
                                        </div>
                                        {/* ژمارەی وەسڵ */}
                                        <div className="col-2 text-right">
                                            <div className="form-group mb-0">
                                                <label className="mb-1" style={{ fontSize: "12px" }}>:ژمارەی وەسڵ</label>
                                                <input
                                                    type="text"
                                                    name="IT_no_invoice"
                                                    value={IT_no_invoice}
                                                    onChange={AddProChange}
                                                    onKeyUp={IT_get_Invoice}
                                                    onMouseEnter={(e) => e.target.style.color = 'black'}
                                                    onMouseLeave={(e) => e.target.style.color = 'white'}
                                                    className="form-control text-center font-weight-bold bg-danger text-white"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        {/* تێبینی */}
                                        <div className="col-3 text-right">
                                            <div className="form-group mb-0">
                                                <label className="mb-1" style={{ fontSize: "12px" }}>:تێبینی</label>
                                                <input
                                                    type="text"
                                                    name="IT_Note"
                                                    value={IT_Note}
                                                    onChange={AddProChange}
                                                    disabled={IT_disabled}
                                                    className="form-control text-right font-weight-bold"
                                                    placeholder="تێبینی..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div style={{ backgroundColor: "#2C3539", padding: "10px 0" }}>
                                    {/* Product Details */}
                                    {IT_items && typeof IT_items === 'object' && IT_items.code ? (
                                        <div className="row text-warning font-weight-bold" style={{ margin: 0 }}>
                                            <div className="col-sm-1"></div>
                                            <div className="col-sm-1 bg-danger text-white">
                                                <NumberFormat
                                                    value={IT_singleSale}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                ></NumberFormat>
                                            </div>
                                            <div className="col-sm-1">
                                                <h4
                                                    className="border b--black"
                                                    style={{ backgroundColor: "#17a2b8", color: "#fff", border: "2px solid #ffc107", fontSize: "20px" }}
                                                    name="dp"
                                                >
                                                    P-| {IT_dp || ""} |-D
                                                </h4>
                                            </div>
                                            <div className="col-sm-1">
                                                <h5
                                                    className="border b--black"
                                                    style={{ backgroundColor: "#32CD32", color: "#000" }}
                                                    name="rasid"
                                                >
                                                    R{" "}
                                                    {Number.isInteger(Number(IT_rasidKarton))
                                                        ? Number(IT_rasidKarton)
                                                        : Number(IT_rasidKarton).toFixed(2)}
                                                </h5>
                                            </div>

                                            <div className="col-sm-1">
                                                <h5
                                                    className="border b--black bg-white text-dark"
                                                    name="kren"
                                                >
                                                    K$ {Number(IT_price).toFixed(2)}
                                                </h5>
                                            </div>
                                            <div className="col-sm-1">
                                                <h6
                                                    className="border b--black bg-white text-dark"
                                                    name="nrxyakkarton"
                                                >
                                                    KK$ {Number(IT_Karton_price).toFixed(2)}
                                                </h6>
                                            </div>
                                            <div className="col-sm-1">
                                                <h5
                                                    className="border b--black bg-white text-dark"
                                                    name="frosthndolar"
                                                >
                                                    $ {IT_saleDolar}
                                                </h5>
                                            </div>
                                            <div className="col-sm-1">
                                                <h5
                                                    className="border b--black bg-white text-dark"
                                                    name="frosthndolar"
                                                >
                                                    2$ {IT_nrxeFroshtnDolar2}
                                                </h5>
                                            </div>
                                            <div className="col-sm-1">
                                                <h6
                                                    className="border b--black bg-white text-dark"
                                                    name="frosthndinar"
                                                >
                                                    ID {Number(IT_saleDinar).toFixed(2)}
                                                </h6>
                                            </div>
                                            <div className="col-sm-1">
                                                <h6
                                                    className="border b--black bg-white text-dark"
                                                    name="frosthndinar"
                                                >
                                                    ID<sup style={{ color: "red" }}>2</sup> {IT_nrxeFroshtnDenar2}
                                                </h6>
                                            </div>
                                            <div className="col-sm-1">
                                                <h6
                                                    className="border b--black bg-white text-dark"
                                                    name="niwkarton"
                                                >
                                                    1/2ID {IT_saleOfLessHalfCarton}
                                                </h6>
                                            </div>
                                            <div className="col-sm-1">
                                                <h6
                                                    className="border b--black bg-white text-dark"
                                                    name="Rkmtrladadrzan"
                                                >{`>10ID ${IT_saleOfLessTenDarzan}`}</h6>
                                            </div>

                                        </div>
                                    ) : null}
                                    {/* Input Form Section */}
                                </div>

                                <form>
                                    <div className="row text-warning font-weight-bold" style={{ backgroundColor: "#2C3539" }}>
                                        <div className="col-1 text-right px-2"></div>

                                        <div className="col-2 text-right px-2">
                                            <div className="form-group">
                                                <label>دانە</label>
                                                <input
                                                    type="text"
                                                    disabled={IT_disabled}
                                                    name="IT_dana"
                                                    value={IT_dana}
                                                    onChange={IT_code ? IT_OnDanaChange : null}
                                                    onKeyPress={(event) => {
                                                        if (event.key === "Enter") {
                                                            if (IT_productNumber) {
                                                                IT_saveDetail(IT_items);
                                                            }
                                                            const codeInput = document.getElementById("SearchItem_");
                                                            if (codeInput) {
                                                                codeInput.value = "";
                                                                codeInput.focus();
                                                            }
                                                        }
                                                    }}
                                                    className="form-control text-right font-weight-bold pr-4"
                                                    id="IT_dana_input"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-2 text-right px-2">
                                            <div className="form-group">
                                                <label>دەرزەن</label>
                                                <input
                                                    type="text"
                                                    disabled={IT_disabled}
                                                    name="IT_darzan"
                                                    value={IT_darzan}
                                                    onChange={IT_code ? IT_OnDarzanChange : null}
                                                    onKeyPress={(event) =>
                                                        event.key === "Enter" ? document.getElementById("IT_dana_input").focus() : null
                                                    }
                                                    className="form-control text-right font-weight-bold pr-4"
                                                    id="IT_darzan_input"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-2 text-right px-2">
                                            <div className="form-group">
                                                <label>کارتۆن</label>
                                                <input
                                                    type="text"
                                                    disabled={IT_disabled}
                                                    name="IT_karton"
                                                    value={IT_karton}
                                                    onChange={IT_code ? IT_OnKartonChange : null}
                                                    onKeyPress={(event) => {
                                                        if (event.key === "Enter") {
                                                            document.getElementById("IT_darzan_input").focus();
                                                        }
                                                    }}
                                                    className="form-control text-right font-weight-bold pr-4"
                                                    id="IT_karton_input"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2 text-right">
                                            <div className="form-group">
                                                <label>ناوی کاڵا</label>
                                                <input
                                                    type="text"
                                                    disabled
                                                    value={IT_itemName}
                                                    className="form-control text-right font-weight-bold"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-2 text-right px-2">
                                            <div className="form-group">
                                                <label>کۆد</label>
                                                <input
                                                    type="text"
                                                    disabled={IT_disabled}
                                                    onKeyPress={(event) => {
                                                        if (event.key === "Enter") {
                                                            event.preventDefault();
                                                            IT_searchItemName(event);
                                                            setTimeout(() => {
                                                                const kartonInput = document.getElementById("IT_karton_input");
                                                                if (kartonInput) kartonInput.focus();
                                                            }, 100);
                                                        }
                                                    }}
                                                    value={IT_code}
                                                    onClick={IT_setItemEmpty}
                                                    name="IT_code"
                                                    onChange={AddProChange}
                                                    className="form-control text-right font-weight-bold tc pr-4"
                                                    id="SearchItem_"
                                                    autoFocus
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </form>


                                {/* Table Section */}
                                <div className="row mt-3" style={{ marginBottom: "120px" }}>
                                    <div className="col-12">
                                        <div style={{ borderRadius: "5px", overflow: "hidden" }}>
                                            <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 350px)", minHeight: "300px" }}>
                                                <table className="table table-hover mb-0 text-white" style={{ direction: "rtl" }}>
                                                    <thead style={{ backgroundColor: "#2C3539", position: "sticky", top: 0, zIndex: 10 }}>
                                                        <tr className="text-center">
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>X</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>کۆد</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>ناوی کاڵا</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>کارتۆن</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>دەرزەن</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>دانە</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>نرخ</th>
                                                            <th style={{ border: "2px solid #4d636f", padding: "25px", color: "#fff" }}>کۆی گشتی</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {IT_table.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="8" className="text-center py-5">
                                                                    <div style={{ padding: "40px 20px" }}>
                                                                        <i className="fa fa-shopping-cart" style={{ fontSize: "60px", color: "#4d636f" }}></i>
                                                                        <p style={{ marginTop: "15px", color: "#999", fontSize: "15px" }}>هیچ کاڵایەک زیاد نەکراوە</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            IT_table.map((item, i) => (
                                                                <tr
                                                                    key={i}
                                                                    className="text-center text-bold"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        transition: "all 0.2s",
                                                                        color: IT_isEdited ? "#999" : "#000",
                                                                    }}
                                                                    onClick={(e) => IT_openEditModel(item, e)}
                                                                >
                                                                    <td style={{ border: "1px solid #555", padding: "8px" }}>
                                                                        <button
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                IT_deleteItem(i, item);
                                                                            }}
                                                                            disabled={IT_disabled}
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontWeight: "bold", fontSize: "25px", direction: "ltr" }}>{item.raqam}</td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", textAlign: "right", fontSize: "25px" }}>{item.nawisht}</td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontSize: "25px" }}>
                                                                        {DecimalNumber(item.carton)}
                                                                    </td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontSize: "25px" }}>{DecimalNumber(item.darzan)}</td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontSize: "25px" }}>{item.dana}</td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontSize: "25px" }}>
                                                                        <NumberFormat
                                                                            value={item.nrx}
                                                                            displayType={"text"}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </td>
                                                                    <td style={{ border: "1px solid #555", padding: "8px", fontWeight: "bold", color: "#4caf50", fontSize: "15px" }}>
                                                                        <NumberFormat
                                                                            value={IT_joripara === "دینار" ? item.kodinar : item.kodolar}
                                                                            displayType={"text"}
                                                                            thousandSeparator={true}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer Section */}


                                {/* Edit Modal */}
                                {
                                    IT_isEdited && (
                                        <div
                                            style={{
                                                position: "fixed",
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                background: "rgba(0, 0, 0, 0.7)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                zIndex: 9999
                                            }}
                                            onClick={IT_closeModel}
                                        >
                                            <div
                                                style={{
                                                    width: "90%",
                                                    maxWidth: "500px",
                                                    backgroundColor: "#2C3539",
                                                    borderRadius: "5px",
                                                    overflow: "hidden"
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div style={{ backgroundColor: "#9900ff", padding: "12px 15px" }}>
                                                    <h5 className="text-white mb-0 font-weight-bold">دەستکاریکردنی کاڵا</h5>
                                                </div>
                                                <div style={{ padding: "20px" }}>
                                                    <div className="form-group">
                                                        <label className="text-white font-weight-bold mb-2">کارتۆن</label>
                                                        <input
                                                            type="number"
                                                            name="IT_karton"
                                                            value={IT_karton}
                                                            onChange={IT_OnKartonChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-center font-weight-bold"
                                                            autoFocus
                                                            style={{ fontSize: "18px", padding: "10px" }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="text-white font-weight-bold mb-2">دەرزەن</label>
                                                        <input
                                                            type="number"
                                                            name="IT_darzan"
                                                            value={IT_darzan}
                                                            onChange={IT_OnDarzanChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-center font-weight-bold"
                                                            style={{ fontSize: "18px", padding: "10px" }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="text-white font-weight-bold mb-2">دانە</label>
                                                        <input
                                                            type="number"
                                                            name="IT_dana"
                                                            value={IT_dana}
                                                            onChange={IT_OnDanaChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-center font-weight-bold"
                                                            style={{ fontSize: "18px", padding: "10px" }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="text-white font-weight-bold mb-2">نرخ</label>
                                                        <input
                                                            type="number"
                                                            name="IT_nrx"
                                                            value={IT_nrx}
                                                            onChange={IT_OnNrxChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-center font-weight-bold bg-warning text-dark"
                                                            style={{ fontSize: "18px", padding: "10px" }}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="font-weight-bold mb-2" style={{ color: Number(IT_editProfit) >= 0 ? "#4caf50" : "#f44336" }}>
                                                            قازانج
                                                        </label>
                                                        <input
                                                            type="number"
                                                            disabled
                                                            value={IT_editProfit || 0}
                                                            className={`form-control text-center font-weight-bold ${Number(IT_editProfit) >= 0 ? "bg-success text-white" : "bg-danger text-white"}`}
                                                            style={{ fontSize: "18px", padding: "10px" }}
                                                        />
                                                    </div>
                                                    <div className="d-flex" style={{ gap: "10px", marginTop: "20px" }}>
                                                        <button
                                                            className="btn btn-success font-weight-bold flex-fill"
                                                            style={{ fontSize: "16px", padding: "10px" }}
                                                            onClick={(e) => IT_updateItemInTable(e, IT_ItemData)}
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            پاشەکەوتکردن
                                                        </button>
                                                        <button
                                                            className="btn btn-danger"
                                                            style={{ padding: "10px 20px" }}
                                                            onClick={IT_closeModel}
                                                        >
                                                            <i className="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                <div
                                    style={{
                                        position: "fixed",
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        backgroundColor: "#2C3539",
                                        borderTop: "3px solid #9900ff",
                                        padding: "15px 20px",
                                        zIndex: 1000
                                    }}
                                >
                                    <div className="row align-items-center">


                                        {/* Totals Section */}
                                        <div className="col-8">
                                            <div className="row text-warning font-weight-bold">
                                                <div className="col-3 text-right">
                                                    <label className="mb-1" style={{ fontSize: "13px" }}>کۆی گشتی</label>
                                                    <input
                                                        type="number"
                                                        disabled
                                                        value={IT_total || 0}
                                                        className="form-control text-right font-weight-bold bg-success text-white"
                                                        style={{ fontSize: "16px", padding: "8px" }}
                                                    />
                                                </div>

                                                <div className="col-2 text-right px-2">
                                                    <label className="mb-1" style={{ fontSize: "13px" }}>داشکان</label>
                                                    <input
                                                        type="text"
                                                        disabled={IT_disabled}
                                                        value={IT_discount}
                                                        onChange={AddProChange}
                                                        onKeyUp={IT_disCount}
                                                        name="IT_discount"
                                                        className="form-control text-right font-weight-bold"
                                                        style={{ fontSize: "16px", padding: "8px" }}
                                                    />
                                                </div>

                                                <div className="col-2 text-right px-2">
                                                    <label className="mb-1" style={{ fontSize: "13px" }}>پارەی دراو</label>
                                                    <input
                                                        type="text"
                                                        disabled={IT_disabled}
                                                        value={IT_paied}
                                                        onChange={AddProChange}
                                                        onKeyUp={IT_countChange}
                                                        name="IT_paied"
                                                        className="form-control text-right font-weight-bold"
                                                        style={{ fontSize: "16px", padding: "8px" }}
                                                    />
                                                </div>

                                                <div className="col-2 text-right px-2">
                                                    <label className="mb-1" style={{ fontSize: "13px" }}>پارەی ماوە</label>
                                                    <input
                                                        type="number"
                                                        disabled
                                                        value={IT_remain || 0}
                                                        className={`form-control text-right font-weight-bold ${parseFloat(IT_remain || 0) < 0 ? "bg-danger text-white" : "bg-success text-white"
                                                            }`}
                                                        style={{ fontSize: "16px", padding: "8px" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Buttons Section */}
                                        <div className="col-1">
                                            <div className="d-flex" style={{ gap: "10px" }}>
                                                <button
                                                    onClick={(e) => {
                                                        IT_createNewPage(e);
                                                        this.onNewPage();
                                                    }}
                                                    className={`btn btn-${(IT_table.length > 0 && !IT_saved) || IT_isOpen || IT_open ? "danger" : "primary"} flex-fill`}
                                                    disabled={(IT_table.length > 0 && !IT_saved) || IT_isOpen || IT_open}
                                                    style={{ padding: "10px" }}
                                                >
                                                    <i className="far fa-file fa-lg"></i>
                                                </button>

                                                {!IT_saved ? (
                                                    <button
                                                        onClick={(e) => this.onSaveChange(IT_name, IT_table, IT_save, e)}
                                                        className="btn btn-success flex-fill"
                                                        disabled={IT_saved || IT_table.length === 0}
                                                        style={{ padding: "10px" }}
                                                    >
                                                        <i className="far fa-save fa-lg"></i>
                                                    </button>
                                                ) : (
                                                    <>
                                                        {IT_isOpen || IT_open ? (
                                                            <button
                                                                onClick={(e) => IT_updateInvoice(IT_invoiceId, e)}
                                                                className="btn btn-warning flex-fill"
                                                                disabled={IT_disabled}
                                                                style={{ padding: "10px" }}
                                                            >
                                                                <i className="fa fa-edit fa-lg"></i>
                                                            </button>
                                                        ) : (
                                                            <button
                                                                        onClick={(e) => {
                                                                            if (L_user && L_user._id && IT_froshtn !== "فرۆشتنی وەکیل") {
                                                                                IT_openInvoice(e, IT_invoiceId, L_user._id);
                                                                            }
                                                                        }}
                                                                className="btn btn-secondary flex-fill"
                                                                style={{ padding: "10px" }}
                                                            >
                                                                <i className="fa fa-lock fa-lg"></i>
                                                            </button>
                                                        )}
                                                        <Link to={IT_isOpen || IT_open ? "/AllMarket" : "/print-single"}>
                                                            <button
                                                                type="button"
                                                                onClick={(e) => getPrint(IT_invoiceId, e)}
                                                                disabled={IT_isOpen || IT_open}
                                                                className="btn btn-info flex-fill"
                                                                style={{ padding: "10px", backgroundColor: "#9900ff", border: "1px solid #9900ff" }}
                                                            >
                                                                <i className="fa fa-print fa-lg"></i>
                                                            </button>
                                                        </Link>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {/* Pagination Controls */}
                                        <div className="col-3 d-flex align-items-end justify-content-center" style={{ gap: "5px" }}>
                                            <button
                                                type="button"
                                                onClick={IT_pageminsone}
                                                className="btn btn-dark p3 px-4"
                                                title="پەڕەی پێشوو"
                                                style={{
                                                    backgroundColor: "#00695c",
                                                    border: "1px solid #00695c"
                                                }}
                                            >
                                                <i className="fa fa-chevron-left"></i>
                                            </button>
                                            <button
                                                type="button"
                                                onClick={IT_pageplusone}
                                                className="btn btn-dark p3 px-4"
                                                title="پەڕەی دواتر"
                                                style={{
                                                    backgroundColor: "#00695c",
                                                    border: "1px solid #00695c"
                                                }}
                                            >
                                                <i className="fa fa-chevron-right"></i>
                                            </button>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }}
                </ProductConsumer >
            </>
        );
    }
}

export default AllMarket;
